import { useCallback, useEffect, useState } from 'react';

export const ACUVERSE_LOGO_V101 = `${
  process.env.PUBLIC_URL || ''
}/branding/acuverse-ad918bca.png`;
export const LOGO_LOAD_TIMEOUT_V101 = 6000;

export function resolveAcuverseLogoV101(value) {
  const source = typeof value === 'string' ? value.trim() : '';
  if (
    !source ||
    ['undefined', 'null', 'logo.png', '/logo.png'].includes(source)
  )
    return ACUVERSE_LOGO_V101;
  if (source === ACUVERSE_LOGO_V101) return source;
  try {
    const url = new URL(source, window.location.href);
    const legacy = new URL(
      `${process.env.PUBLIC_URL || ''}/logo.png`,
      window.location.href
    );
    if (url.origin === legacy.origin && url.pathname === legacy.pathname)
      return ACUVERSE_LOGO_V101;
    if (
      url.hostname === 'raw.githubusercontent.com' &&
      /^\/heing8848\/my-save\/(?:refs\/heads\/main|main|ad918bcabb13f868911fff5d0d729265a9a1ef38)\/Acuverse\.png$/.test(
        url.pathname
      )
    )
      return ACUVERSE_LOGO_V101;
    if (
      ['http:', 'https:'].includes(url.protocol) ||
      /^data:image\//i.test(source)
    )
      return source;
  } catch (_) {}
  return ACUVERSE_LOGO_V101;
}

export function useAcuverseLogoV101(configured) {
  const candidate = resolveAcuverseLogoV101(configured);
  const [ready, setReady] = useState(null);
  useEffect(() => {
    if (candidate === ACUVERSE_LOGO_V101) return undefined;
    const image = new Image();
    let active = true;
    const release = () => {
      active = false;
      clearTimeout(timeout);
      image.onload = null;
      image.onerror = null;
      image.removeAttribute('src');
    };
    const finish = (success) => {
      if (!active) return;
      setReady(success ? candidate : null);
      release();
    };
    const timeout = setTimeout(() => finish(false), LOGO_LOAD_TIMEOUT_V101);
    image.onload = () =>
      finish(image.naturalWidth > 0 && image.naturalHeight > 0);
    image.onerror = () => finish(false);
    image.referrerPolicy = 'no-referrer';
    image.src = candidate;
    return release;
  }, [candidate]);

  // Keep the bundled image visible until a custom logo has actually loaded.
  const logo = ready === candidate ? candidate : ACUVERSE_LOGO_V101;
  const onLogoError = useCallback(
    () => setReady((current) => (current === candidate ? null : current)),
    [candidate]
  );
  return { logo, onLogoError };
}
